import React from 'react'
import BuildingList from '../../components/kiosk/KioskContent/BuildingList/BuildingList'
import {fetchFloor} from '../../api/floor'
import {useUIDispatch} from '../../context/UIContext'
import {isServiceCatalog} from '../../utils/routing'
import {LOGON_CONTAINER} from '../../constants/const'
import {
  fetchAndSetUserDefaultLocation,
  useUserDispatch
} from '../../context/UserContext'

const BuildingListPage = () => {
  const uiDispatch = useUIDispatch()
  const userDispatch = useUserDispatch()

  const isCatalogView = isServiceCatalog()

  const onCancel = () =>
    uiDispatch({type: 'setContent', payload: {content: LOGON_CONTAINER}})

  const onBuildingSelect = async ({blId}) => {
    const flId = await fetchFloor({blId})

    uiDispatch({
      type: 'setActiveFloor',
      payload: {blId, flId}
    })

    uiDispatch({
      type: 'setHomeFloor',
      payload: {blId, flId}
    })

    await fetchAndSetUserDefaultLocation({
      userDispatch,
      blId,
      flId
    })

    uiDispatch({
      type: 'setContent',
      payload: {content: isCatalogView ? 'SERVICE_CATALOG' : 'DASHBOARD'}
    })
  }

  return (
    <BuildingList onCancel={onCancel} onBuildingSelect={onBuildingSelect} />
  )
}

export default BuildingListPage
